import React from 'react';
import { FileRecord, WorkOrder } from '@twinsketch/topika-model';
import RenderFileList from 'src/components/file/workorder/RenderFileList';
import ExcelFileUploader from 'src/components/file/workorder/ExcelFileUploader';

interface FileUploadAndListTabProps {
  files: FileRecord[];
  workOrderId: string;
  isWorkOrderCreated: boolean;
  workOrderData: WorkOrder;
  extractedFileIds: string[];
  setWorkOrderData: (data: any) => void;
  setError: (error: string | null) => void;
}

const FileUploadAndListTab: React.FC<FileUploadAndListTabProps> = ({
  files,
  workOrderId,
  isWorkOrderCreated,
  workOrderData,
  extractedFileIds,
  setWorkOrderData,
  setError,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <ExcelFileUploader
        workOrderId={workOrderId}
        isWorkOrderCreated={isWorkOrderCreated}
        workOrderData={workOrderData}
        setWorkOrderData={setWorkOrderData}
        setError={setError}
      />
      <div
        style={{
          height: '3px',
          backgroundColor: '#ddd',
          margin: '16px 0',
          width: '100%',
        }}
      />
      <RenderFileList
        files={files}
        workOrderId={workOrderId}
        workOrderData={workOrderData}
        extractedFileIds={extractedFileIds}
        setWorkOrderData={setWorkOrderData}
        setError={setError}
      />
    </div>
  );
};

export default FileUploadAndListTab;
